<template>
    <div style="width: 1082px">
        <template v-if="isToasterWithPackingWorkOrder">
            <Toaster2Polaris3PopcornPage :work-order="workOrder" :css="css" />
            <Toaster2Polaris3PackingPage :work-order="workOrder" :css="css" />
        </template>

        <template v-else-if="isFryerWithPackingWorkOrder">
            <FryerPolaris3FryingPage :work-order="workOrder" :css="css" />
            <FryerPolaris3PackingPage :work-order="workOrder" :css="css" />
        </template>

        <template v-else-if="isFryerOnlyWorkOrder">
            <FryerOnlyFryingPage :work-order="workOrder" :css="css" />
        </template>

        <template v-else>
            <table :style="[css.workOrderTable]" style="width: 100%; page-break-before: always !important">
                <!-- MAX cols 15 per row -->
                <tbody>
                    <tr :style="[css.tr]">
                        <td colspan="3" :style="[css.td, css.paddingBig, css.colorGray, css.text14]">
                            Vastutava operaatori NIMI
                        </td>
                        <td colspan="5" :style="[css.td, css.paddingBig, css.colorBlue]"></td>
                        <td colspan="3" :style="[css.td, css.paddingBig, css.colorGray, css.text14]">
                            Vastutava operaatori ALLKIRI
                        </td>
                        <td colspan="4" :style="[css.td, css.paddingBig, css.colorBlue]"></td>
                    </tr>
                    <tr :style="[css.tr]">
                        <td colspan="7" :style="[css.td, css.paddingBig, css.colorGray, css.textSmall]">
                            Kinnitan "X", et liinilt on eemaldatud eelmise toote tootmiseks kulunud toorained:
                        </td>
                        <td colspan="1" :style="[css.td, css.paddingBig, css.colorBlue]"></td>

                        <td colspan="1" :style="[css.td, css.paddingBig, css.colorGray, css.textSmall]">Märkused:</td>
                        <td colspan="6" :style="[css.td, css.paddingBig, css.colorBlue]"></td>
                    </tr>
                    <tr :style="[css.tr]">
                        <td colspan="7" :style="[css.td, css.paddingBig, css.colorGray, css.textSmall]">
                            Kinnitan "X", et töökoht, seadme osad ja tarvikud on ENNE TOOTMIST ilma nähtavate
                            vigastusteta ja puhtad:
                        </td>
                        <td colspan="1" :style="[css.td, css.paddingBig, css.colorBlue]"></td>

                        <td colspan="1" :style="[css.td, css.paddingBig, css.colorGray, css.textSmall]">Märkused:</td>
                        <td colspan="6" :style="[css.td, css.paddingBig, css.colorBlue]"></td>
                    </tr>
                    <tr :style="[css.tr]">
                        <td colspan="7" :style="[css.td, css.paddingBig, css.colorGray, css.textSmall]">
                            Kinnitan "X", et töökoht, seadme osad ja tarvikud on PEALE TOOTMIST ilma nähtavate
                            vigastusteta ja puhtad:
                        </td>
                        <td colspan="1" :style="[css.td, css.paddingBig, css.colorBlue]"></td>

                        <td colspan="1" :style="[css.td, css.paddingBig, css.colorGray, css.textSmall]">Märkused:</td>
                        <td colspan="6" :style="[css.td, css.paddingBig, css.colorBlue]"></td>
                    </tr>
                    <tr :style="[css.tr]" v-if="!isToasterLineNumber">
                        <td colspan="7" :style="[css.td, css.paddingBig, css.colorGray, css.textSmall]">
                            Kinnitan "X", et tootmisprotsess on vastavuses tootekaardiga:
                        </td>
                        <td colspan="1" :style="[css.td, css.paddingBig, css.colorBlue]"></td>

                        <td colspan="1" :style="[css.td, css.paddingBig, css.colorGray, css.textSmall]">Märkused:</td>
                        <td colspan="6" :style="[css.td, css.paddingBig, css.colorBlue]"></td>
                    </tr>
                    <tr :style="[css.tr]" style="height: 4px !important">
                        <td
                            colspan="15"
                            :style="[css.noBorderTopBottom, css.textExtraSmall]"
                            style="height: 4px !important"
                        ></td>
                    </tr>

                    <tr :style="[css.tr]">
                        <td v-if="isToasterWorkOrder" colspan="15" :style="[css.td, css.paddingSmall, css.colorGray]">
                            SEIRE (tootmise alustamisel, peale seisakut ja 1x tunnis tootmise ajal)
                        </td>

                        <td v-else colspan="15" :style="[css.td, css.paddingSmall, css.colorGray]">
                            SEIRE (1x tunnis tootmise ajal)
                        </td>
                    </tr>

                    <tr :style="[css.tr]">
                        <td colspan="2" :style="[css.td, css.colorGray, css.paddingSmall]">Teostamise aeg</td>
                        <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                        <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                        <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                        <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                        <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                        <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                        <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                        <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                        <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                        <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                        <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                        <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                        <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                    </tr>

                    <template v-if="isToasterLineNumber">
                        <tr :style="[css.tr]">
                            <td colspan="2" :style="[css.td, css.colorGray, css.paddingSmall]">
                                Ahju temperatuur, (°C)
                            </td>
                            <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                            <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                            <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                            <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                            <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                            <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                            <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                            <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                            <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                            <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                            <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                            <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                            <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                        </tr>

                        <tr :style="[css.tr]">
                            <td colspan="2" :style="[css.td, css.colorGray, css.paddingSmall]">
                                Trumli pöörlemiskiirus
                            </td>
                            <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                            <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                            <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                            <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                            <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                            <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                            <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                            <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                            <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                            <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                            <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                            <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                            <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                        </tr>

                        <tr :style="[css.tr]">
                            <td colspan="2" :style="[css.td, css.colorGray, css.paddingSmall]">
                                Õli pealeandmise näit
                            </td>
                            <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                            <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                            <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                            <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                            <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                            <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                            <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                            <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                            <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                            <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                            <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                            <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                            <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                        </tr>
                    </template>
                    <template v-else>
                        <tr :style="[css.tr]">
                            <td rowspan="3" :style="[css.td, css.colorGray, css.paddingSmall]">Toote kaal (g)</td>
                            <td :style="[css.td, css.colorGray, css.textRed, css.paddingSmall]">Toode 1</td>
                            <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                            <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                            <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                            <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                            <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                            <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                            <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                            <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                            <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                            <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                            <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                            <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                            <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                        </tr>

                        <tr :style="[css.tr]">
                            <td :style="[css.td, css.colorGray, css.textRed, css.paddingSmall]">Toode 2</td>
                            <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                            <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                            <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                            <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                            <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                            <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                            <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                            <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                            <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                            <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                            <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                            <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                            <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                        </tr>

                        <tr :style="[css.tr]">
                            <td :style="[css.td, css.colorGray, css.textRed, css.paddingSmall]">Toode 3</td>
                            <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                            <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                            <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                            <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                            <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                            <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                            <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                            <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                            <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                            <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                            <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                            <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                            <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                        </tr>
                    </template>

                    <tr v-if="!isPackingLineNumber" :style="[css.tr]">
                        <td colspan="2" :style="[css.td, css.colorGray, css.paddingSmall]">
                            Toote maitse/tekstuur (+/-)
                        </td>
                        <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                        <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                        <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                        <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                        <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                        <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                        <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                        <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                        <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                        <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                        <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                        <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                        <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                    </tr>

                    <tr v-if="isToasterLineNumber" :style="[css.tr]">
                        <td colspan="2" :style="[css.td, css.colorGray, css.paddingSmall]">Pooltoote mahukaal (g/L)</td>
                        <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                        <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                        <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                        <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                        <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                        <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                        <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                        <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                        <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                        <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                        <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                        <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                        <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                    </tr>

                    <tr :style="[css.tr]" v-if="workOrder.gas_packing">
                        <td rowspan="2" :style="[css.td, css.colorGray, css.paddingSmall]">Gaasi sisaldus</td>
                        <td :style="[css.td, css.colorGray, css.paddingSmall]">Rõhk, bar</td>
                        <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                        <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                        <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                        <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                        <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                        <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                        <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                        <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                        <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                        <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                        <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                        <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                        <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                    </tr>

                    <tr :style="[css.tr]" v-if="workOrder.gas_packing">
                        <td :style="[css.td, css.colorGray, css.paddingSmall]">Hapnik, %</td>
                        <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                        <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                        <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                        <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                        <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                        <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                        <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                        <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                        <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                        <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                        <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                        <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                        <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                    </tr>
                    <tr :style="[css.tr]" v-if="workOrder.gas_packing">
                        <td colspan="2" :style="[css.td, css.colorGray, css.paddingSmall]">Gaasi triipkoodi number</td>
                        <td colspan="4" :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                    </tr>
                    <tr v-if="!isToasterWorkOrder" :style="[css.tr]">
                        <td rowspan="2" :style="[css.td, css.colorGray, css.paddingSmall]">Ahju parameetrid</td>
                        <td :style="[css.td, css.colorGreen, css.paddingSmall]">Põleti temp. C&deg</td>
                        <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                        <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                        <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                        <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                        <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                        <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                        <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                        <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                        <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                        <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                        <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                        <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                        <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                    </tr>

                    <tr v-if="!isToasterWorkOrder" :style="[css.tr]">
                        <td :style="[css.td, css.colorRed, css.paddingSmall]">Tegelik temp. C&deg</td>
                        <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                        <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                        <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                        <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                        <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                        <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                        <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                        <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                        <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                        <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                        <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                        <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                        <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                    </tr>

                    <tr :style="[css.tr]" style="height: 4px !important">
                        <td colspan="15" :style="[css.noBorderTopBottom]" style="height: 4px !important"></td>
                    </tr>

                    <tr v-if="!isPackingLineNumber" :style="[css.tr]">
                        <td colspan="15" :style="[css.td, css.paddingSmall, css.colorGray]">
                            SEIRE (tootmise alustamisel / peale seisakut)
                        </td>
                    </tr>

                    <template v-if="!isPackingLineNumber">
                        <tr :style="[css.tr]">
                            <td colspan="2" :style="[css.td, css.paddingSmall, css.colorGray]">Teostamise kellaaeg</td>
                            <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                            <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                            <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                            <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                            <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                            <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                            <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                            <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                            <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                            <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                            <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                            <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                            <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                        </tr>

                        <tr :style="[css.tr]">
                            <td
                                v-if="isToasterLineNumber"
                                colspan="2"
                                :style="[css.td, css.paddingSmall, css.colorGray]"
                            >
                                Maitseaine pealeandmise näit
                            </td>
                            <td v-else colspan="2" :style="[css.td, css.paddingSmall, css.colorGray]">
                                Maitsestaja näit
                            </td>
                            <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                            <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                            <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                            <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                            <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                            <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                            <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                            <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                            <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                            <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                            <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                            <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                            <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                        </tr>

                        <tr :style="[css.tr]">
                            <td colspan="2" :style="[css.td, css.paddingSmall, css.colorGray]">
                                {{ isPopcornProduction ? "Maitseaine kogus 60s" : "Maitseaine kogus 30s" }}
                            </td>
                            <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                            <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                            <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                            <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                            <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                            <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                            <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                            <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                            <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                            <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                            <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                            <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                            <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                        </tr>

                        <tr :style="[css.tr]" v-if="!isToasterLineNumber">
                            <td colspan="2" :style="[css.td, css.paddingSmall, css.colorGray]">
                                Maitsestaja aukude suurus
                            </td>
                            <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                            <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                            <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                            <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                            <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                            <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                            <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                            <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                            <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                            <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                            <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                            <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                            <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                        </tr>

                        <tr :style="[css.tr]" v-if="!isToasterLineNumber">
                            <td colspan="2" :style="[css.td, css.paddingSmall, css.colorGray]">Valtside kiirus</td>
                            <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                            <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                            <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                            <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                            <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                            <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                            <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                            <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                            <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                            <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                            <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                            <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                            <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                        </tr>

                        <tr :style="[css.tr]" v-if="!isToasterLineNumber">
                            <td colspan="2" :style="[css.td, css.paddingSmall, css.colorGray]">Trumli kiirus</td>
                            <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                            <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                            <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                            <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                            <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                            <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                            <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                            <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                            <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                            <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                            <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                            <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                            <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                        </tr>
                    </template>
                </tbody>
            </table>
            <table :style="[css.workOrderTable]" style="width: 100%; margin-top: 4px">
                <tbody>
                    <tr :style="[css.tr]">
                        <td :style="[css.td, css.colorGray, css.width100]" rowspan="7">Jäätmed</td>
                        <td :style="[css.td, css.colorGray, css.textLeft]">Põhjus</td>
                        <td :style="[css.td, css.colorGray]" colspan="4">Kogus (kg)</td>
                        <td :style="[css.minWidth20]"></td>
                        <td :style="[css.td, css.colorGray, css.width100]" rowspan="7">Seisakute ja Rikete põhjused</td>
                        <td :style="[css.td, css.colorGray]">Min</td>
                        <td :style="[css.td, css.colorGray]" colspan="6">
                            Märkused (Toote kvaliteedi puudus, tooraine puudus, tehniline rike, muu seisak):
                        </td>
                    </tr>
                    <tr :style="[css.tr]" v-for="(n, item) in maxWasteAndDowntimeRowsCount">
                        <td :style="[css.td, css.textLeft, css.colorYellow]">
                            {{ workOrder.wastes[item] ? workOrder.wastes[item].reason : "" }}
                        </td>
                        <td colspan="4" :style="[css.td, css.textLeft, css.colorYellow]">
                            {{ workOrder.wastes[item] ? workOrder.wastes[item].quantity : "" }}
                        </td>
                        <td></td>
                        <td :style="[css.td, css.colorGray, css.colorYellow]">
                            {{
                                workOrder.downtimes_and_breakdowns[item]
                                    ? workOrder.downtimes_and_breakdowns[item].time_in_minutes
                                    : ""
                            }}
                        </td>
                        <td colspan="6" :style="[css.td, css.colorGray, css.colorYellow]">
                            {{
                                workOrder.downtimes_and_breakdowns[item]
                                    ? workOrder.downtimes_and_breakdowns[item].notes
                                    : ""
                            }}
                        </td>
                    </tr>
                </tbody>
            </table>
            <table
                :style="[css.workOrderTable]"
                style="width: 100%; page-break-before: always"
                v-if="!isToasterWorkOrder"
            >
                <!-- MAX cols 15 per row -->
                <tbody>
                    <tr :style="[css.tr]">
                        <td colspan="15" :style="[css.td, css.paddingSmall, css.colorGray]">VAHVLISEGU SEIRE</td>
                    </tr>
                    <tr :style="[css.tr]">
                        <td :colspan="2" :style="[css.td, css.paddingSmall, css.colorGray]">Tootmistellimuse nr</td>
                        <td :colspan="2" :style="[css.td, css.paddingSmall, css.colorPurple]">
                            {{ workOrder.production_order_number }}
                        </td>
                        <td :style="[css.td, css.paddingSmall, css.colorGray, css.textSmall]">Tootmise kuupäev</td>
                        <td :style="[css.td, css.paddingSmall, css.colorPurple]">{{ workOrder.production_date }}</td>
                        <td :rowspan="2" :style="[css.td, css.paddingSmall, css.colorGray]">Eeldatav kestus</td>
                        <td :colspan="2" :style="[css.td, css.paddingSmall, css.colorPurple]">
                            {{ workOrder.estimated_time }}
                        </td>
                        <td :colspan="2" :style="[css.td, css.paddingSmall, css.colorGray]">Planeeritud kogus kg</td>
                        <td :colspan="2" :style="[css.td, css.paddingSmall, css.colorPurple]">
                            {{ workOrder.planned_quantity }}
                        </td>
                        <td :style="[css.td, css.paddingSmall, css.colorGray]">Partii / BB</td>
                        <td :style="[css.td, css.paddingSmall, css.colorGray]">Vahetuse nr. 1-4</td>
                    </tr>
                    <tr :style="[css.tr]">
                        <td :style="[css.td, css.paddingSmall, css.colorGray]">Toodetav partii</td>
                        <td :colspan="3" :style="[css.td, css.paddingSmall, css.colorPurple]">
                            {{ workOrder.production_order_number }}
                        </td>
                        <td :style="[css.td, css.paddingSmall, css.colorGray, css.text8]">Tootmise algusaeg</td>
                        <td :style="[css.td, css.paddingSmall, css.colorPurple]">{{ workOrder.production_time }}</td>
                        <td :colspan="2" :style="[css.td, css.paddingSmall, css.colorPurple]">
                            {{ getEstimationTime("long", true) }}
                        </td>
                        <td :colspan="2" :style="[css.td, css.paddingSmall, css.colorGray]">Müügitellimuse nr</td>
                        <td :colspan="2" :style="[css.td, css.paddingSmall, css.colorPurple]">
                            {{ workOrder.sales_order_number }}
                        </td>
                        <td :style="[css.td, css.paddingSmall, css.colorBlue]"></td>
                        <td :style="[css.td, css.paddingSmall, css.colorBlue]"></td>
                    </tr>

                    <tr :style="[css.tr]">
                        <td :style="[css.td, css.paddingSmall, css.colorGray]">Toote kood</td>
                        <td :style="[css.td, css.paddingSmall, css.colorPurple]">{{ workOrder.product_code }}</td>
                        <td colspan="2" :style="[css.td, css.paddingSmall, css.colorGray]">Toote nimi</td>
                        <td colspan="5" :style="[css.td, css.paddingSmall, css.colorPurple]">
                            {{ workOrder.product_name }}
                        </td>
                        <td :style="[css.td, css.paddingSmall, css.colorGray]">Toote EAN</td>
                        <td colspan="3" :style="[css.td, css.paddingSmall, css.colorPurple]">
                            {{ workOrder.product_ean }}
                        </td>
                        <td :style="[css.td, css.paddingSmall, css.colorGray]">Retsept RS-16</td>
                        <td :style="[css.td, css.paddingSmall, css.colorBlue]"></td>
                    </tr>
                    <tr :style="[css.tr]">
                        <td :colspan="2" :style="[css.td, css.paddingSmall, css.colorGray]">Tootmise kuupäev</td>
                        <td :colspan="2" :style="[css.td, css.paddingSmall, css.colorBlue]"></td>

                        <td :colspan="2" :style="[css.td, css.paddingSmall, css.colorGray]">Tootmise algusaeg</td>
                        <td :colspan="3" :style="[css.td, css.paddingSmall, css.colorBlue]"></td>

                        <td :colspan="2" :style="[css.td, css.paddingSmall, css.colorGray]">Tootmise lõpu kellaaeg</td>
                        <td :colspan="2" :style="[css.td, css.paddingSmall, css.colorBlue]"></td>

                        <td :style="[css.td, css.paddingSmall, css.colorGray]">Retsept RS-17</td>
                        <td :style="[css.td, css.paddingSmall, css.colorBlue]"></td>
                    </tr>
                    <tr :style="[css.tr]" style="height: 6px !important">
                        <td colspan="13" :style="[css.td, css.noBorderTopBottom]" style="height: 6px !important"></td>
                        <td rowspan="2" :style="[css.td, css.colorGray]" style="height: 6px !important">
                            Muu retsept (nr.)
                        </td>
                        <td rowspan="2" :style="[css.td, css.colorBlue]" style="height: 6px !important"></td>
                    </tr>

                    <tr :style="[css.tr]">
                        <td rowspan="2" colspan="2" :style="[css.td, css.paddingSmall, css.colorGray]">
                            Kasutatud tooraine
                        </td>
                        <td rowspan="2" colspan="4" :style="[css.td, css.paddingSmall, css.colorGray]">Partii</td>
                        <td rowspan="2" colspan="2" :style="[css.td, css.paddingSmall, css.colorGray, css.textSmall]">
                            Partiivahetuse kellaaeg
                        </td>
                        <td rowspan="2" :style="[css.td, css.paddingSmall, css.colorGray, css.text8]">
                            Partii vahetus segust nr.
                        </td>
                        <td :style="[css.paddingSmall, css.noBorderTopBottom]"></td>
                        <td :style="[css.td, css.paddingSmall, css.colorGray]">Vahvliliin 1</td>
                        <td :style="[css.td, css.paddingSmall, css.colorBlue]"></td>
                        <td :style="[css.paddingSmall, css.noBorderTopBottom]"></td>
                    </tr>

                    <tr :style="[css.tr]">
                        <td :style="[css.paddingSmall, css.noBorderTopBottom]"></td>
                        <td :style="[css.td, css.paddingSmall, css.colorGray]">Vahvliliin 2</td>
                        <td :style="[css.td, css.paddingSmall, css.colorBlue]"></td>
                        <td colspan="3" :style="[css.paddingSmall, css.noBorderTopBottom]"></td>
                    </tr>

                    <tr
                        :style="[css.tr]"
                        v-for="(ingredient, i) in maxIngredientsRowsCount"
                        :key="`wo_ingredient_${i}`"
                    >
                        <td :style="[css.td, css.colorPurple, css.text8, css.heightMin]">
                            {{ filteredIngredients[i] ? filteredIngredients[i].product_code : "" }}
                        </td>
                        <td :style="[css.td, css.colorPurple, css.text8, css.heightMin]">
                            {{ filteredIngredients[i] ? filteredIngredients[i].product_name : "" }}
                        </td>
                        <td colspan="4" :style="[css.td, css.colorPurple, css.text8, css.heightMin]">
                            {{ filteredIngredients[i] ? filteredIngredients[i].product_batch : "" }}
                        </td>
                        <td :style="batchChangeTimeCellCss(i)" colspan="2" :rowspan="batchChangeTimeCellRowspan(i)">
                            {{ batchTimeChangeText(i) }}
                        </td>
                        <td :style="batchChangeTimeCellCss(i, 'blue')" :rowspan="batchChangeTimeCellRowspan(i)"></td>
                        <td :style="[css.noBorderTopBottom, css.text8, css.heightMin]" v-if="i < 2"></td>
                        <td :style="[css.td, css.colorGray, css.paddingSmall]" v-if="i === 0">Vahvliliin 3</td>
                        <td :style="[css.td, css.colorBlue, css.text8, css.heightMin]" v-if="i === 0"></td>
                        <td colspan="2" :style="[css.noBorderTopBottom, css.text8, css.heightMin]" v-if="i === 1"></td>
                        <td colspan="6" :style="[css.td, css.colorGray, css.text8, css.heightMin]" v-if="i === 2">
                            Märkused (vee koguse muutmine, praak, jäätmed, katkestused jms):
                        </td>
                        <td colspan="6" :style="[css.td, css.colorBlue, css.text8, css.heightMin]" v-if="i > 2"></td>
                        <td colspan="3" :style="[css.noBorderTopBottom, css.text8, css.heightMin]" v-else></td>
                    </tr>
                    <tr :style="css.tr" style="height: 4px !important">
                        <td style="height: 4px !important"></td>
                    </tr>
                    <tr :style="[css.tr]">
                        <td :style="[css.td, css.paddingSmall, css.colorGray]">Segu nr.</td>
                        <td :style="[css.td, css.paddingSmall, css.colorGray]">Segu valmimise kellaaeg</td>
                        <td colspan="2" :style="[css.td, css.paddingSmall, css.colorGray]">Teostaja (nimi)</td>
                        <td :style="[css.td, css.paddingSmall, css.colorGray]">Segu nr.</td>
                        <td :style="[css.td, css.paddingSmall, css.colorGray]">Segu valmimise kellaaeg</td>
                        <td colspan="2" :style="[css.td, css.paddingSmall, css.colorGray]">Teostaja (nimi)</td>
                        <td :style="[css.td, css.paddingSmall, css.colorGray]">Segu nr.</td>
                        <td :style="[css.td, css.paddingSmall, css.colorGray]">Segu valmimise kellaaeg</td>
                        <td colspan="2" :style="[css.td, css.paddingSmall, css.colorGray]">Teostaja (nimi)</td>
                        <td colspan="3" :style="[css.paddingSmall, css.noBorderTopBottom]"></td>
                    </tr>

                    <tr :style="[css.tr]" v-for="(item, index) in 20">
                        <td :style="[css.td, css.paddingCustom, css.colorGray, css.textSmall]">{{ index + 1 }}</td>
                        <td :style="[css.td, css.paddingCustom, css.colorBlue, css.textSmall]"></td>
                        <td colspan="2" :style="[css.td, css.paddingCustom, css.colorBlue, css.textSmall]"></td>
                        <td :style="[css.td, css.paddingCustom, css.colorGray, css.textSmall]">{{ index + 21 }}</td>
                        <td :style="[css.td, css.paddingCustom, css.colorBlue, css.textSmall]"></td>
                        <td colspan="2" :style="[css.td, css.paddingCustom, css.colorBlue, css.textSmall]"></td>
                        <td :style="[css.td, css.paddingCustom, css.colorGray, css.textSmall]">{{ index + 41 }}</td>
                        <td :style="[css.td, css.paddingCustom, css.colorBlue, css.textSmall]"></td>
                        <td colspan="2" :style="[css.td, css.paddingCustom, css.colorBlue, css.textSmall]"></td>
                        <td
                            rowspan="3"
                            colspan="2"
                            :style="[css.td, css.paddingCustom, css.colorGray, css.text7]"
                            v-if="index === 0"
                        >
                            Kinnitan "X", et töökoht, seadme osad ja tarvikud on ENNE TOOTMIST ilma nähtavate
                            vigastusteta ja puhtad:
                        </td>
                        <td
                            rowspan="3"
                            :style="[css.td, css.paddingCustom, css.colorBlue, css.text7]"
                            v-if="index === 0"
                        ></td>
                        <td
                            rowspan="3"
                            colspan="2"
                            :style="[css.td, css.paddingCustom, css.colorGray, css.text7]"
                            v-if="index === 3"
                        >
                            Kinnitan "X", et töökoht, seadme osad ja tarvikud on PEALE TOOTMIST ilma nähtavate
                            vigastusteta ja puhtad:
                        </td>
                        <td
                            rowspan="3"
                            :style="[css.td, css.paddingCustom, css.colorBlue, css.text7]"
                            v-if="index === 3"
                        ></td>
                        <td
                            colspan="3"
                            :style="[css.td, css.paddingCustom, css.colorGray, css.text8]"
                            v-if="index === 6"
                        >
                            Märkused:
                        </td>
                        <td
                            colspan="3"
                            :style="[css.td, css.paddingCustom, css.colorBlue, css.text7]"
                            v-if="index > 6 && index < 13"
                        ></td>
                        <td
                            colspan="3"
                            :style="[css.td, css.paddingCustom, css.colorGray, css.text8]"
                            v-if="index === 13"
                        >
                            Vastutava segutegija nimi
                        </td>
                        <td
                            rowspan="2"
                            colspan="3"
                            :style="[css.td, css.paddingCustom, css.colorBlue, css.text8]"
                            v-if="index === 14"
                        ></td>
                        <td
                            colspan="3"
                            :style="[css.td, css.paddingCustom, css.colorGray, css.text8]"
                            v-if="index === 16"
                        >
                            Vastutava segutegija allkiri
                        </td>
                        <td
                            rowspan="3"
                            colspan="3"
                            :style="[css.td, css.paddingCustom, css.colorBlue, css.text8]"
                            v-if="index === 17"
                        ></td>
                    </tr>
                </tbody>
            </table>
        </template>
    </div>
</template>

<script>
import moment from "moment/moment";
import { mapGetters } from "vuex";
import Toaster2Polaris3PackingPage from "./pages/toaster-2-polaris-3-packing-page.vue";
import Toaster2Polaris3PopcornPage from "./pages/toaster-2-polaris-3-popcorn-page.vue";
import FryerPolaris3PackingPage from "@/pages/work-order/table/pages/fryer-polaris-3-packing-page.vue";
import FryerPolaris3FryingPage from "@/pages/work-order/table/pages/fryer-polaris-3-frying-page.vue";
import FryerOnlyFryingPage from "@/pages/work-order/table/pages/fryer-only-frying-page.vue";

export default {
    name: "work-order-view-table-printing",
    components: {
        FryerPolaris3FryingPage,
        FryerPolaris3PackingPage,
        FryerOnlyFryingPage,
        Toaster2Polaris3PopcornPage,
        Toaster2Polaris3PackingPage,
    },
    props: {
        workOrder: Object,
    },
    data() {
        return {
            waffleAllowedProductCodes: ["8210", "8211", "8345", "8348", "8350"],
            css: {
                workOrderTable: {
                    width: "100%",
                    borderCollapse: "collapse",
                    fontWeight: "bold",
                    textAlign: "center",
                    fontFamily: "Calibri, sans-serif",
                    fontSize: "10px",
                },
                tr: {
                    pageBreakInside: "avoid !important",
                },
                td: {
                    border: "0.5px solid black",
                    borderCollapse: "collapse",
                    padding: "2px",
                    fontSize: "10px",
                    width: "120px",
                },

                paddingSmall: {
                    height: "21px !important",
                },
                paddingBig: {
                    padding: "8px",
                    height: "35px",
                },
                colorGray: {
                    backgroundColor: "#d9d9d9",
                },
                colorBlue: {
                    backgroundColor: "#e0eaf6",
                },
                colorRed: {
                    backgroundColor: "#ed702d",
                },
                colorGreen: {
                    backgroundColor: "#9fce63",
                },
                hidden: {
                    display: "none",
                },
                colorPurple: {
                    fontSize: "12px",
                    backgroundColor: "#f7cefc",
                },
                colorYellow: {
                    fontSize: "12px",
                    backgroundColor: "#fdf3d0",
                },
                textLeft: {
                    textAlign: "left",
                },
                minWidth70: {
                    minWidth: "70px",
                },
                minWidth20: {
                    minWidth: "24px",
                },
                minWidth100: {
                    minWidth: "100px",
                },
                textRed: {
                    color: "red",
                },
                width250: {
                    width: "250px",
                },
                width100: {
                    width: "100px",
                },
                noBorderTopBottom: {
                    borderTop: "0px solid white",
                    borderBottom: "0px solid white",
                },
                noBorder: {
                    border: "none !important",
                },
                textSmall: {
                    fontSize: "9px",
                },
                text8: {
                    fontSize: "8px",
                },
                text7: {
                    fontSize: "7px",
                },
                text14: {
                    fontSize: "14px",
                },
                textExtraSmall: {
                    fontSize: "3px",
                },
                heightMin: {
                    height: "18px !important",
                },
                paddingCustom: {
                    height: "18px !important",
                },
            },
        };
    },
    computed: {
        ...mapGetters("WorkOrderStore", [
            "isToasterWorkOrder",
            "isToasterLineNumber",
            "isPackingLineNumber",
            "isPopcornProduction",
            "isToasterWithPackingWorkOrder",
            "isFryerWithPackingWorkOrder",
            "isFryerOnlyWorkOrder",
        ]),

        filteredIngredients() {
            return (
                this.workOrder.ingredients.filter((ingredient) =>
                    this.waffleAllowedProductCodes.includes(ingredient.product_code)
                ) || []
            );
        },

        maxIngredientsRowsCount() {
            return Math.max(this.filteredIngredients.length, 6);
        },

        maxWasteAndDowntimeRowsCount() {
            let maxValue = 6;
            if (this.isToasterLineNumber) maxValue = 5;
            return Math.max(this.workOrder.wastes.length, this.workOrder.downtimes_and_breakdowns.length, maxValue);
        },
    },
    methods: {
        batchChangeTimeCellCss(index, color = "yellow") {
            const ingredients = this.filteredIngredients;
            if (!ingredients[index]) {
                return [this.css.td, this.css.heightMin];
            }
            if (ingredients[index].batch_change_time !== null) {
                let customColor = this.css.colorYellow;

                if (color === "blue") {
                    customColor = this.css.colorBlue;
                }
                return [this.css.td, customColor, this.css.heightMin];
            } else if (
                index !== 0 &&
                ingredients[index - 1].batch_change_time !== null &&
                ingredients[index - 1].product_code === ingredients[index].product_code
            ) {
                return [this.css.hidden, this.css.heightMin];
            } else {
                return [this.css.td, this.css.heightMin];
            }
        },
        batchChangeTimeCellRowspan(index) {
            const ingredients = this.filteredIngredients;
            if (!ingredients[index]) {
                return 1;
            }
            if (
                ingredients[index].batch_change_time !== null &&
                index < ingredients.length - 1 &&
                ingredients[index].product_code === ingredients[index + 1].product_code &&
                ingredients[index + 1].batch_change_time === null
            ) {
                return 2;
            } else {
                return 1;
            }
        },
        batchChangeTimeCellRowspanForBlue(index) {
            const ingredients = this.workOrder.ingredients;
            if (
                ingredients[index].batch_change_time !== null &&
                index < ingredients.length - 1 &&
                ingredients[index].product_code === ingredients[index + 1].product_code &&
                ingredients[index + 1].batch_change_time === null
            ) {
                return 2;
            } else {
                return 1;
            }
        },
        getEstimationTime(type, isString = false) {
            if (!this.workOrder.estimated_time) {
                return "-";
            }
            let hours = null;
            let minutes = null;
            let seconds = null;

            if (isString) {
                let result = this.workOrder.estimated_time.match(/\b([\d]*)\b/g);

                if (result.length !== 4) return "-";
                if (!result[0] || !result[2]) return "-";

                minutes = parseInt(result[0]);
                seconds = result[2];
                hours = parseInt(minutes / 60);

                if (hours) {
                    minutes -= hours * 60;
                }
            } else {
                let time = moment(this.workOrder.estimated_time, "HH:mm:ss");
                hours = time.hours();
                minutes = time.minutes();
                seconds = time.seconds();
            }

            if (type === "long") {
                return `${hours}h${minutes}min${seconds}sek`;
            } else {
                return `${hours * 60 + minutes}:${seconds}`;
            }
        },
        batchTimeChangeText(i) {
            const ingredients = this.filteredIngredients;
            if (!ingredients[i]) {
                return "";
            }
            if (ingredients[i].batch_change_time === "00:00" || !ingredients[i].batch_change_time) {
                return "";
            }

            return ingredients[i].batch_change_time;
        },
    },
};
</script>

<style scoped lang="scss"></style>
